import {
  DEFAULT_SERVER_PORT,
  DEPLOY_ENVS,
  apiHostForEnv,
  clientHostForEnv,
  pagesHostForEnv,
} from "@fortress/shared";

// Single source of truth for the client's server endpoint, derived from the
// page's hostname at runtime (domain scheme in @fortress/shared constants).
// `VITE_SERVER_URL` overrides everything — for tooling and special builds
// only (the verify skill's isolated stack, Capacitor apps whose WebView
// hostname is localhost); deployed builds never set it.
//   {env-client-host} / fortress-client-{env}.pages.dev → wss://{env-api-host}
//   anything else (localhost, LAN) → current hostname on the default port
function deployedApiHost(hostname: string): string | undefined {
  for (const env of DEPLOY_ENVS) {
    const pages = pagesHostForEnv(env);
    if (
      hostname === clientHostForEnv(env) ||
      hostname === pages ||
      hostname.endsWith(`.${pages}`) // wrangler preview deployments
    ) {
      return apiHostForEnv(env);
    }
  }
  return undefined;
}

/** WebSocket URL of the Colyseus server. */
export function serverWsUrl(): string {
  const override = import.meta.env.VITE_SERVER_URL;
  if (override) return override;
  const api = deployedApiHost(window.location.hostname);
  if (api) return `wss://${api}`;
  const proto = window.location.protocol === "https:" ? "wss" : "ws";
  return `${proto}://${window.location.hostname}:${DEFAULT_SERVER_PORT}`;
}

/** HTTP origin of the same server — for the /auth REST calls and /app-state. */
export function serverHttpUrl(): string {
  return serverWsUrl().replace(/^ws(s?):\/\//, "http$1://");
}
